import { BaseApiRequest } from "../baseApiRequest";
import { Route, RouteTypes } from "../../types";
import { XcoreCore } from "XcoreCore";

export interface RouteParsed extends Omit<Route, "routeType"> {
  routeType: RouteTypes;
}

export type ListRoutesResponse = RouteParsed[];

export const listRoutes = (core: XcoreCore): BaseApiRequest<ListRoutesResponse> =>
  core.fetch("/api/route", core.getCtx()).then((r) => r.json());
